export default __webpack_public_path__ + "static/media/Q20_0_resized.7ad932e9.jpg";